/* src/app/auth/resend/resend.component.scss */
/*# sourceMappingURL=resend.component-YWQFP57O.css.map */
